"use strict";

function validateFormElement($obj){
  let $name, $val, $formName = null;
  
  $name = $obj.attr('name');
  $val = $obj.val();
  $formName = $('#formName').val();

  $.ajax({
    type: "POST",
    url: "/app/form.php",
    data: { 
      formName: $formName, 
      validation : 'singleElement', 
      name : $name, 
      value : $val
    },
    'success': function(data){
      //$('div.ajaxReturnStr').append(data);
      var obj = jQuery.parseJSON(data);
      //console.log( 'obj: ' + obj);
      
      if(obj === true){
        $('#submitOrder').removeClass('formNotValid');
        // errorWrapper entfernen
        $('.f-ErrorWrapper_' + $name + '')
          .fadeOut(250, function(){
            $(this).remove();
        });
        

      } else {
        if (!$('#submitOrder').hasClass('formNotValid')){
          $('#submitOrder').addClass('formNotValid');
        }
        buildErrorWrapper(obj, $name);
      }
    }
  });
};

function buildErrorWrapper(obj, $name){
  let $errorWrapperMarkUp, $e, $amountErr = null;
  // bestehenden errorWrapper ggf. entfernen
  $('.f-ErrorWrapper_' + $name + '').remove();

  // errorWrapper bauen
  $errorWrapperMarkUp = '<div class="f-ErrorWrapper '
                      + 'f-ErrorWrapper_' + $name + '">' 
                      + '<ul class="f-ErrorList">';

  //console.log( typeof obj + ": " + $name);
  // Fehlermeldungen als Listenpunkte einfügen
  if (typeof obj[$name] === 'undefined') {// complete form validation
    $e = obj;
  } else {
    $e = obj[$name];// single validation
  }
  
  $.each( $e, function( key1, value1 ) {
    //console.log( "key1:" + key1 + " => " + value1);
    $errorWrapperMarkUp += '<li>' + value1 + '</li>';
  });

  $errorWrapperMarkUp += '</ul></div>';

  // errorWrapper in entsprechenden FormElement-Container platzieren
  $('[name="' + $name + '"]').not('[type="hidden"]').after($errorWrapperMarkUp);                            

  // errorWrapper ggf. anpassen
  $amountErr = $('.f-ErrorWrapper_' + $name + ' li').length;
  if ($amountErr <= 1) {
    $('.f-ErrorWrapper_' + $name + ' .f-ErrorList')
      .addClass('f-ErrorList-single');
  }
}

let $form = $('.js-container > form');
let formName = $form.attr('name');
let formVanilla = document.querySelector('.js-container > form');
let $uploadAllComplete = false;
let $uploaderElement = document.getElementById("uploader");
//console.info($uploaderElement);
//
// Position vom Intro
let $header = $('#main-header');
let headerOffset = $header.offset();
//console.log(headerOffset);

// Position vom Bestellformular
let offset = $form.offset();
let offsetTop = 500;//offset.top - 25;

// use Fine Uploader UI for traditional endpoints
import qq from 'fine-uploader';

if (formName === 'contact') {  
  $form.submit(function(){
      //console.log( $uploadAllComplete );
      $.ajax({
          type: "POST",
          url: "/app/form.php",
          data: $form.serialize(),
          'success': function(data){
              //console.log( data );
              //$('div.ajaxReturnStr').empty().append(data);
              var obj = jQuery.parseJSON(data);
              //console.log( "obj: " + obj.success);

              if(obj.success === true){
                  $('#submitOrder').removeClass('formNotValid');
                  $('.f-ErrorWrapper').remove();

                  $form.trigger("reset");//zum Testen auskommentieren
                  $("body, html").animate({
                      scrollTop : headerOffset.top
                  }, 500);
                  $('#intro').hide();
                  $('.js-container').hide();
                  $('.js-ThanxContainer').fadeIn();
                  $('.js-content-types > section').hide();
                  //console.log($('.f-Container'));

              } else {
                  if (!$('#submitOrder').hasClass('formNotValid')){
                      $('#submitOrder').addClass('formNotValid');
                  }
                  $.each( obj, function( key, value ) {
                      buildErrorWrapper(value, key);
                  });
              }
          }
      });

      return false;
  });
  
} else {  
    const qquploader = new qq.FineUploader({
    debug: false,
    element: $uploaderElement,//document.getElementById("uploader"),
    autoUpload: false,
    request: {
      endpoint: '/app/form.php'
    },
    cors: {
        //all requests are expected to be cross-domain requests
        expected: true,

        //if you want cookies to be sent along with the request
        sendCredentials: true
    },
    deleteFile: {
        enabled: true,
        endpoint: '/app/form.php'
    },
    validation: {
        allowedExtensions: ['pdf']//, 'doc', 'docx'
    },
    notAvailablePath: '/app/fine-uploader/placeholders/not_available-generic.png',
    messages: {
        emptyError: '{file} ist leer.',
        noFilesError: 'Keine Dateien zum Hochladen ausgewählt.',
        onLeave: 'Dateien werden hochgeladen. Wenn Sie die Seite jetzt verlassen wird das Hochladen abgebrochen.',
        sizeError: '{file} ist zu groß. Die maxime Dateigröße beträgt {sizeLimit}.',
        typeError: '{file} hat das falsche Dateiformat. Gültige Formate sind: {extensions}.',
        failUpload: 'Das Hochladen ist fehlgeschlagen.',
        formatProgress: '{percent}% von {total_size} ',
        paused: 'angehalten',
        waitingForResponse: 'in Bearbeitung …',
        confirmMessage: 'Sind Sie sicher, dass Sie die Datei »{filename}« löschen möchten?',
        deletingFailedText: 'Das Löschen ist fehlgeschlagen.',
        deletingStatusText: 'wird gelöscht …',
        forceConfirm: true,
        unsupportedBrowser: 'Nicht zu behebender Fehler - Der Browser erlaubt kein Hochladen von Dateien jeglicher Art.'
    },
    callbacks: {
        onAllComplete: function(param) {
            let uploads = this.getUploads();

            $.each( uploads, function( i, obj ) {
                $('#fieldset-upload').append(
                    '<input type="hidden" name="upload-id[' + i + ']" value="' + obj.id + '">' +
                    '<input type="hidden" name="upload-uuid[' + i + ']" value="' + obj.uuid + '">' +
                    '<input type="hidden" name="upload-name[' + i + ']" value="' + obj.name + '">' +
                    '<input type="hidden" name="upload-status[' + i + ']" value="' + obj.status + '">\n'
                );
                //$.each( obj, function( k, v ) {
                    //console.log( i + ": " + k + ' :: ' + v);                        
                    //name :: test Ä Ö Ü.pdf
                    //originalName :: test Ä Ö Ü.pdf
                    //uuid :: 72a6c11d-2b42-461d-a397-0a77f3580c0e
                    //size :: 122226
                    //status :: upload successful
                    //batchId :: f10c7ccc-696c-48d9-ac2c-9bf34525414c
                    //id :: 2
                //});
            });
            //$uploadAllComplete = true;
            $form.submit();
        }
    }
  });
  //console.log( 'uploader: ' + qquploader );

  $form.submit(function(){
      let $uploadAmount = $('.qq-upload-list li').length;
      let $uploadAmountSuccess = $('.qq-upload-list li.qq-upload-success').length;

      if ($uploadAmount !== 0) {
          if ($uploadAmount !== $uploadAmountSuccess) {
              //console.log( 'uploader: ' + qq.uploader );
              qquploader.uploadStoredFiles();
          } else {
              $uploadAllComplete = true;
          }            

      } else {
          $uploadAllComplete = true;
      }

      if ($uploadAllComplete === true) {
        //console.log( $uploadAllComplete );
        $.ajax({
            type: "POST",
            url: "/app/form.php",
            data: $form.serialize(),
            'success': function(data){
                //console.log(data);
                //$('div.ajaxReturnStr').empty().append(data);

                var obj = jQuery.parseJSON(data);
                //console.log( "obj: " + obj.success);

                if(obj.success === true){
                    $('#submitOrder').removeClass('formNotValid');
                    $('.f-ErrorWrapper').remove();

                    $form.trigger("reset");//zum Testen auskommentieren
                    $("body, html").animate({
                        scrollTop : headerOffset.top
                    }, 500);
                    $('#intro').hide();
                    $('.js-container').hide();
                    $('.to-hide-on-submit').hide();
                    $('.js-ThanxContainer').fadeIn();
                    $('.js-content-types > section').hide();
                    //console.log($('.f-Container'));

                } else {
                    if (!$('#submitOrder').hasClass('formNotValid')){
                        $('#submitOrder').addClass('formNotValid');
                    }
                    $.each( obj, function( key, value ) {
                        //console.log( '@107 - ' + key + ": " + value);
                        buildErrorWrapper(value, key);
                    });
                }
            }
        });
      }
      return false;
  });  
}

//console.log( $form.attr('name') );

$('.js-kontaktart').change(function(){
    if ($(this).val() == 2 || $(this).val() == 3){
        $('.js-option').fadeIn();
    } else {
        $('.js-option').fadeOut();
    }
});

$('.f-ThanxContainer-CodeButton').click(function(){
    $('.qq-upload-list').empty();
    $('#intro').fadeIn();
    $('.js-container').fadeIn();
    $('.js-ThanxContainer').hide();
    $('.js-content-types > section').fadeIn();
});

// input-Felder onblur prüfen
$form.find('input, textarea')
    .not('[type="checkbox"]')
    .blur(function(){
        validateFormElement($(this));
    }
);

// select-Felder onchange prüfen
$form.find('select').change(function(){
    validateFormElement($(this));
});
